export const cn = {
    rightAside: {
        close: '关闭',
    },
}

export const en = {
    rightAside: {
        close: 'Close',
    },
}

export const jp = {
    rightAside: {
        close: '閉じる',
    },
}

export const tw = {
    rightAside: {
        close: '關閉',
    },
}
